
//Navigation
export const setupPrevNextBtns = (prevBtn,nextBtn,embla) =>{
  prevBtn.addEventListener('click',embla.scrollPrev,false);
  nextBtn.addEventListener('click',embla.scrollNext,false);
};

// disable buttons

export const disablePrevNextBtns = (prevBtn, nextBtn, embla) => {
return () => {
  if (embla.canScrollPrev()) prevBtn.removeAttribute('disabled');
  else prevBtn.setAttribute('disabled', 'disabled');

  if (embla.canScrollNext()) nextBtn.removeAttribute('disabled');
  else nextBtn.setAttribute('disabled', 'disabled');
};
};

//lazyload

export const lazeload = (embla,multipleImages=false) => {
  const slides = embla.slideNodes();
  let images = slides.map(slide => slide.querySelector(".embla__slide__img"));
  if(multipleImages){
    images = slides.map(slide => slide.querySelectorAll(".embla__slide__img"))
  }
  const imagesInView = [];

  const addImageLoadEvent = (image, callback) => {
    image.addEventListener("load",callback);
    return () => image.removeEventListener("load",callback);
  };

  const loadImagesInView = () => {
    embla
    .slidesInView(true)
    .filter(index => imagesInView.indexOf(index) === -1)
    .forEach(loadImageInView);
  };

  const loadImageInView = index => {
    let image = images[index];
    if(multipleImages && image.length > 1){
      image.forEach((img,imgIndex)=>{
        image = img;
        const slide = slides[index];
        imagesInView.push(index);
        image.src = image.getAttribute("data-embla-lazy");
        const removeImageLoadEvent = addImageLoadEvent(image,() => {
          slide.classList.add("has-loaded");
          removeImageLoadEvent();
        });
      })
    }
    else{
      const slide = slides[index];
      imagesInView.push(index);
      image.src = image.getAttribute("data-embla-lazy");
      const removeImageLoadEvent = addImageLoadEvent(image,() => {
        slide.classList.add("has-loaded");
        removeImageLoadEvent();
      });
    }


  };

  return () => {
    loadImagesInView();
    return imagesInView.length === images.length;
  };
};


//dots & pagination

//setup dot btns
export const setupDotBtns = (dotsArray, embla) => {
  dotsArray.forEach((dotNode, i) => {
    dotNode.addEventListener("click", () => embla.scrollTo(i), false);
  });
};
// select dot btn
 export const selectDotBtn = (dotsArray, embla) => () => {
  const previous = embla.previousScrollSnap();
  const selected = embla.selectedScrollSnap();
  dotsArray[previous]?.classList?.remove("is-selected");
  dotsArray[selected]?.classList?.add("is-selected");
};



